export class ForbiddenError extends Error {}
